import { ReactNode, useEffect } from 'react';
import { QueryClientProvider, useQuery } from '@tanstack/react-query';
import { I18nProvider } from '@react-aria/i18n';
import { Toast } from '@heroui/react';
import { appConfigQueryOptions } from '../api/app-config';
import { queryClient } from '../lib/query-client';
import { useAuthBootstrap } from '../hooks/useAuth';
import { applyTheme, useThemeStore } from '../stores/themeStore';
import { setRuntimeSkipPhoneVerification } from '../utils/phone';
import { ClarityBootstrap } from '../features/analytics/clarity-bootstrap';

function AuthBootstrap({ children }: { children: ReactNode }) {
  useAuthBootstrap();
  return <>{children}</>;
}

function ThemeBootstrap({ children }: { children: ReactNode }) {
  const theme = useThemeStore((s) => s.theme);
  // Garante sincronia após hydrate (ex.: StrictMode)
  applyTheme(theme);
  return <>{children}</>;
}

function AppConfigBootstrap({ children }: { children: ReactNode }) {
  const configQuery = useQuery(appConfigQueryOptions);

  useEffect(() => {
    if (configQuery.data) {
      setRuntimeSkipPhoneVerification(configQuery.data.skipPhoneVerification);
      return;
    }
    if (configQuery.isError) {
      setRuntimeSkipPhoneVerification(null);
    }
  }, [configQuery.data, configQuery.isError]);

  return <>{children}</>;
}

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nProvider locale="pt-BR">
        <Toast.Provider placement="bottom start" />
        <ThemeBootstrap>
          <AppConfigBootstrap>
            <AuthBootstrap>
              <ClarityBootstrap />
              {children}
            </AuthBootstrap>
          </AppConfigBootstrap>
        </ThemeBootstrap>
      </I18nProvider>
    </QueryClientProvider>
  );
}
